import { Component, Input } from '@angular/core';

@Component({
  selector: 'settings-button',
  templateUrl: './settings-button.component.html',
  styleUrls: ['./settings-button.component.scss']
})
export class SettingsButtonComponent {

  @Input() title: string = '';
  @Input() variant: 'nav' | 'external' = 'nav';

}
